import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipsDefaultOptions } from '@angular/material/chips';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';

const defaultMaterialCheckboxOptions: MatCheckboxDefaultOptions = {
   color: 'primary',
};

const defaultMaterialFormFieldOptions: MatFormFieldDefaultOptions = {
   appearance: 'outline',
   floatLabel: 'always',
};

const defaultMaterialSnackBarOptions: MatSnackBarConfig = {
   duration: 2500,
   horizontalPosition: 'center',
   verticalPosition: 'top',
};

const defaultMaterialChipsOptions: MatChipsDefaultOptions = {
   separatorKeyCodes: [ENTER, COMMA],
};

export const materialProviders = [
   { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: defaultMaterialSnackBarOptions },
   { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: defaultMaterialCheckboxOptions },
   { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: defaultMaterialFormFieldOptions },
   { provide: MAT_CHIPS_DEFAULT_OPTIONS, useValue: defaultMaterialChipsOptions },
];
